import Vue from 'vue'

export default {
  UPDATE_SUBJECT (state, subjectList) {
    state.subjects = subjectList
  },

  UPDATE_CLASS (state, classList) {
    state.classes = classList
  },

  UPDATE_CATEGORY (state, categoryList) {
    state.categories = categoryList
  },

  UPDATE_ASSIGNED (state, assignedClassSubjects) {
    state.assigned = assignedClassSubjects
  }
  // UPDATE_STATUS_CHAT (state, obj) {
  //   obj.rootState.AppActiveUser.status = obj.value
  // },

  // API AFTER
  // SEND_CHAT_MESSAGE (state, payload) {
  //   if (payload.chatData) {
  //     // If there's already chat. Push msg to existing chat
  //     state.chats[Object.keys(state.chats).find(key => Number(key) === payload.id)].msg.push(payload.msg)
  //   } else {
  //     // Create New chat and add msg
  //     const chatId = payload.id
  //     Vue.set(state.chats, [chatId], { isPinned: payload.isPinned,
  //       msg: [payload.msg] })
  //   }
  // },

}